import type { ReactNode } from "react";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { useIsNewOnboardingFlow } from "../hooks/useIsNewOnboardingFlow";
import { NewCommunityAuthLayout } from "./NewCommunityAuthLayout";
import { OnboardingLayout } from "./OnboardingLayout";
import { OnboardingSplitLayout } from "./OnboardingSplitLayout/index";

export interface OnboardingWrapperProps {
  background?: "dark" | "light" | "discover";
  children: ReactNode;
  customMarginTop?: string;
  isNarrow?: boolean;
  isRegisteringAsACommunityMember?: boolean;
  isSignUpOrLogIn?: boolean;
  isVerticallyCenteredOnMobile?: boolean;
  progress?: {
    new: {
      currentStep: number;
      totalSteps: number;
    };
    legacy: string;
  };
  rightPanel?: ReactNode;
  shouldShowPoweredByCircle?: boolean;
  step?: string;
  subtitle?: ReactNode;
  title: ReactNode;
  withCircleBranding?: boolean;
}

export const OnboardingWrapper = ({
  children,
  title,
  subtitle,
  step,
  progress,
  isNarrow = false,
  withCircleBranding = true,
  shouldShowPoweredByCircle = false,
  isVerticallyCenteredOnMobile = false,
  background = "dark",
  rightPanel,
  isRegisteringAsACommunityMember = false,
  customMarginTop,
  isSignUpOrLogIn = false,
}: OnboardingWrapperProps) => {
  const { currentCommunity } = useCurrentCommunityContext();
  const { isNewOnboardingFlow } = useIsNewOnboardingFlow();

  if (
    isNewOnboardingFlow &&
    !isRegisteringAsACommunityMember &&
    isSignUpOrLogIn
  ) {
    return (
      <NewCommunityAuthLayout title={title} subtitle={subtitle}>
        {children}
      </NewCommunityAuthLayout>
    );
  }

  if (!isNewOnboardingFlow || isRegisteringAsACommunityMember) {
    return (
      <OnboardingLayout
        community={currentCommunity}
        title={title}
        subtitle={subtitle}
        step={step}
        progress={progress?.legacy}
        isNarrow={isNarrow}
        withCircleBranding={withCircleBranding}
        shouldShowPoweredByCircle={shouldShowPoweredByCircle}
        isVerticallyCenteredOnMobile={isVerticallyCenteredOnMobile}
        background={background}
      >
        {children}
      </OnboardingLayout>
    );
  }

  return (
    <OnboardingSplitLayout
      title={title}
      subtitle={subtitle}
      progress={progress?.new}
      rightPanel={rightPanel}
      customMarginTop={customMarginTop}
    >
      {children}
    </OnboardingSplitLayout>
  );
};
